import React from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import { shopContent } from '../../../../constants/copyright';
import { useTranslation } from '../../../../translations';
import { useLanguageControls } from '../../../../hooks/useLanguageControls';
const { info } = shopContent;
import ShopInfoGift from './ShopInfoGift';
import ShopInfoText from './ShopInfoText';

const ShopInfo = React.forwardRef(function ShopInfo({}, ref) {
  const { t } = useTranslation();
  const { getLocalizedText } = useLanguageControls();

  return (
    <div className={'shop__info'}>
      <ShopInfoGift info={info} />
      <ShopInfoText info={info} />
    </div>
  );
});

export default ShopInfo;
ShopInfo.propTypes = {};
